const e = "https://www.gstatic.com/recaptcha/releases", o = () => {
  window.___grecaptcha_cfg = void 0;
  const c = document.querySelector(
    'script[src*="/recaptcha/"]:not([src*="gstatic"])'
  );
  c && c.remove();
  const t = document.querySelector(`script[src^="${e}"]`);
  t && t.remove();
};
export {
  e as GSTATIC_URL,
  o as removeGoogleReCaptchaScript
};
//# sourceMappingURL=removeGoogleReCaptchaScript.js.map
